// src/pages/FMSService.jsx

import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const FMSService = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-blue-950 text-white min-h-screen py-10 px-6 md:px-12 lg:px-24">
      {/* Heading */}
      <h1
        className="text-4xl md:text-4xl font-bold mb-6 text-center text-sky-400"
        data-aos="fade-up"
      >
        Facility Management Services (FMS)
      </h1>

      {/* Subheading */}
      <p
        className="text-lg md:text-xl mb-12 text-center max-w-4xl mx-auto"
        data-aos="fade-up"
      >
        Our Facility Management Services (FMS) ensure seamless, secure, and
        efficient IT operations by offering on-site support, asset management,
        incident resolution, and preventive maintenance.
      </p>

      {/* Grid with Image + Offerings */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-start">
        {/* Left Side: Image */}
        <div data-aos="fade-right">
          <img
            src="/servicepages/fm.png"
            alt="FMS Services"
            className="rounded-2xl w-full h-auto shadow-lg"
          />
        </div>

        {/* Right Side: Offerings */}
        <div data-aos="fade-left">
          <h2 className="text-3xl font-semibold mb-4 text-sky-300">
            Key Offerings:
          </h2>
          <ul className="list-disc list-inside text-lg space-y-3">
            <li>On-site Technical Support</li>
            <li>Proactive IT Infrastructure Monitoring</li>
            <li>Inventory & Asset Management</li>
            <li>Helpdesk & Incident Management</li>
            <li>Scheduled Preventive Maintenance</li>
            <li>Vendor Coordination and Escalation</li>
            
          </ul>
        </div>
      </div>

      {/* CTA Button - visible on load */}
      <div className="mt-16 text-center">
        <a
          href="/contact"
          className="inline-block bg-gray-50 text-blue-950 px-8 py-3 rounded-md font-semibold hover:text-sky-400 transition"
        >
          Talk to Our Experts
        </a>
      </div>
    </div>
  );
};

export default FMSService;
